import { UploadStrategyBase } from './upload-strategy-base';
import { DocService } from '@services/doc.service';
import { FileType } from '@models/file-type';
import { map, Observable } from 'rxjs';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class  NativeRedactionUploadStrategy extends UploadStrategyBase {
	public title = 'Manual  Native Redaction';
	public message = 'From here you can upload a document that has its Native file been previously redacted outside of eDiscoveryPlatform using another desktop redaction tool. The file extension of the redacted file must match the extension of the Native.  Upload previously redacted document:';
	private warningIfRedactedDocumentAlreadyExists = 'Warning: A redacted document already exists. Uploading a new redacted Native will overwrite existing redacted document.';
	private errorIfCaseIsAlreadyProcessing: string = 'Cannot upload Redacted Native while document is processing.';

	constructor(protected docService: DocService, protected store: DocViewerStore) {
		super(docService, store);
	}

	public warning$(): Observable<string> {
		return this.store.currentDocument$.pipe(
			map((currentDocument) => currentDocument.status.isRedacted ? this.warningIfRedactedDocumentAlreadyExists : '')
		);
	}

	public error$(): Observable<string> {
		return this.store.currentDocument$.pipe(
			map((currentDocument) => currentDocument.status.isRedactionProcessing ? this.errorIfCaseIsAlreadyProcessing : '')
		);
	}

	public tryUpload(file: File): Observable<string> {

		return this.uploadInternal(file, FileType.RedactedNativeFile);
	}
}
